import { Link } from "wouter";
import { Phone, Mail, MapPin } from "lucide-react";
import craneFullLogo from "@assets/crane-logo-6E7QMWbM-removebg-preview_1774122076170.png";

export function Footer() {
  return (
    <footer className="bg-crane-black text-slate-200">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Brand */}
          <div className="space-y-4">
            <Link href="/">
              <div className="bg-white rounded-md px-4 py-2 inline-block cursor-pointer">
                <img src={craneFullLogo} alt="Crane Consumables" width="1960" height="580" className="h-12 w-auto" />
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Your trusted partner for high-quality label solutions. Manufacturing excellence in Ohio since 2007.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg text-white">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link href="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link href="/products" className="hover:text-primary transition-colors">Products</Link></li>
              <li><Link href="/industries" className="hover:text-primary transition-colors">Industries</Link></li>
              <li><Link href="/services" className="hover:text-primary transition-colors">Services</Link></li>
              <li><Link href="/careers" className="hover:text-primary transition-colors">Careers</Link></li>
              <li><Link href="/contact" className="hover:text-primary transition-colors">Get a Quote</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg text-white">Contact</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span>155 Wright Dr.<br />Middletown, OH 45044</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <a href="tel:+15135399980" className="hover:text-primary transition-colors">(513) 539-9980</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <a href="mailto:sales@craneconsumables.com" className="hover:text-primary transition-colors">sales@craneconsumables.com</a>
              </li>
            </ul>
          </div>

          {/* OEM Specifications */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg text-white">Quality Assurance</h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              Our products are designed to meet or exceed OEM specifications.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 text-center text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} Crane Consumables. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
